import { render, staticRenderFns } from "./short_expiries.vue?vue&type=template&id=185e2d8a&"
import script from "./short_expiries.vue?vue&type=script&lang=js&"
export * from "./short_expiries.vue?vue&type=script&lang=js&"
import style0 from "./short_expiries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports